import React from "react";
import { SlidingPaneIconOrder, } from "@frameworks/web/components/generic/SlidingPaneIconBlock/iSlidingpane";
import Edelicon from "../Edelicon";
export const MarketIconBlock = (props) => {
    const [orderOfIcons, setOrderOfIcons] = React.useState([
        {
            propNameAllowingIcon: props.isViewQuote,
            icon: (React.createElement(Edelicon, { className: "edel-icon-view-quote-outline font-small-12px ", paths: 6 })),
            title: "View Quote",
            IconPropType: SlidingPaneIconOrder.isViewQuote,
        },
        {
            propNameAllowingIcon: props.isQuote,
            icon: React.createElement(Edelicon, { className: "edel-icon-view-quote-outline", paths: 6 }),
            title: "Quote",
            IconPropType: SlidingPaneIconOrder.isQuote,
        },
        {
            propNameAllowingIcon: props.isAddToWatchlist,
            icon: (React.createElement(Edelicon, { className: "edel-icon-watchlist-color font-small-12px ", paths: 3 })),
            title: "Add to Watchlist",
            IconPropType: SlidingPaneIconOrder.isAddToWatchlist,
        },
        {
            propNameAllowingIcon: props.isAddAlert,
            icon: React.createElement(Edelicon, { className: "edel-icon-set-alert-outline", paths: 5 }),
            title: "Add Alert",
            IconPropType: SlidingPaneIconOrder.isAddAlert,
        },
        {
            propNameAllowingIcon: props.isReadReport,
            icon: React.createElement(Edelicon, { className: "edel-icon-read-report" }),
            title: "Read Report",
            IconPropType: SlidingPaneIconOrder.isReadReport,
        },
        {
            propNameAllowingIcon: props.isOptionChain,
            icon: React.createElement(Edelicon, { className: "edel-icon-option-chain" }),
            title: "Option Chain",
            IconPropType: SlidingPaneIconOrder.isOptionChain,
        },
        {
            propNameAllowingIcon: props.isGtdOrder,
            icon: React.createElement(Edelicon, { className: "edel-icon-watchlist-calender" }),
            title: "GTD Order",
            IconPropType: SlidingPaneIconOrder.isGtdOrder,
        },
        {
            propNameAllowingIcon: props.isUnpin,
            icon: React.createElement(Edelicon, { className: "edel-icon-pin-large" }),
            title: "Pin / Unpin",
            IconPropType: SlidingPaneIconOrder.isUnpin,
        },
        {
            propNameAllowingIcon: props.isMore,
            icon: React.createElement(Edelicon, { className: "edel-icon-dots-three-horizontal" }),
            title: "More",
            IconPropType: SlidingPaneIconOrder.isMore,
        },
        {
            propNameAllowingIcon: props.isPledge,
            icon: React.createElement(Edelicon, { className: "edel-icon-pledge-coloured", paths: 2 }),
            title: "Pledge",
            IconPropType: SlidingPaneIconOrder.ispledge,
        },
        {
            propNameAllowingIcon: props.isAif,
            icon: React.createElement(Edelicon, { className: "edel-icon-download-coloured", paths: 2 }),
            title: "Download AIF statement",
            IconPropType: SlidingPaneIconOrder.isAif,
        },
        {
            propNameAllowingIcon: props.isChart,
            icon: React.createElement(Edelicon, { className: "edel-icon-charts", paths: 5 }),
            title: "Charts",
            IconPropType: SlidingPaneIconOrder.isChart,
        },
    ]);
    React.useEffect(() => {
        if (props.order) {
            let temp = [];
            props.order.map((ele) => {
                orderOfIcons.find((x) => {
                    if (x.IconPropType === ele)
                        temp.push(x);
                });
            });
            setOrderOfIcons(temp);
        }
    }, [props.order]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `slidingpane-icon-block ${props.parentClass ? props.parentClass : ""}` }, orderOfIcons.map((iconElemnent, idx) => {
            return (iconElemnent.propNameAllowingIcon && (React.createElement("div", { className: iconElemnent.IconPropType ===
                    SlidingPaneIconOrder.isReadReport && props.newReport
                    ? "icon-tile mt-20"
                    : "icon-tile", key: idx, onClick: () => {
                    var _a, _b;
                    (_b = (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.find((icon) => icon.type === iconElemnent.IconPropType)) === null || _b === void 0 ? void 0 : _b.action();
                } },
                React.createElement("div", { className: "hand_cursor" },
                    typeof iconElemnent.icon === "string" ? (React.createElement("i", { className: iconElemnent.icon })) : (iconElemnent.icon),
                    React.createElement("div", { className: "icon-text margin-top-13" }, iconElemnent.title),
                    iconElemnent.IconPropType ===
                        SlidingPaneIconOrder.isReadReport &&
                        props.newReport && (React.createElement("div", { className: "new-report d-flex justify-content-center" },
                        React.createElement("span", null, "New")))))));
        }))));
};
